"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const node_1 = require("../node");
const sort_1 = require("./sort");
class PageNode extends node_1.default {
    static from(obj) {
        if (obj['type'] === 'page')
            return new PageNode(obj['pageSize'], obj['page']);
        return null;
    }
    constructor(pageSize, page) {
        super('Page node');
        this.pageSize = pageSize;
        this.page = page;
    }
    checkPort(portNumber) {
        return portNumber === 0;
    }
    getSignature(datasetRepo) {
        if (!this.incoming[0])
            return null;
        return this.incoming[0].getSignature(datasetRepo);
    }
    validate(datasetRepo) {
        if (!this.incoming[0])
            return false;
        let pageValid = this.pageSize > 0 && this.page >= 0;
        let hasSort = false;
        this.dfs(node => {
            if (node instanceof sort_1.default)
                hasSort = true;
        });
        return pageValid && (this.page === 0 || hasSort) && this.incoming[0].validate(datasetRepo);
    }
    serialize() {
        return super.serialize({
            type: 'page',
            pageSize: this.pageSize,
            page: this.page,
        });
    }
}
exports.default = PageNode;
